import React, {useState} from 'react';
import { FaRegArrowAltCircleDown, FaRegArrowAltCircleUp} from "react-icons/fa";

export default function View({question, answer}) {
    const [show, setShow]=useState(false)
    return (
        <main>
            <div class="container2">
                <div className="quest">
                    <h3>{question}</h3>
                    <button onClick={()=>setShow(!show)}>
                        {show ? <FaRegArrowAltCircleUp className="icon"/> : <FaRegArrowAltCircleDown className="icon"/>  }
                    </button>
                </div>
                {
                    show && <p>{answer}</p> 
                }
                 
            </div>
            
        </main>
    )
}
